export const formMessages = {
    required: () => 'Обязательное поле',
    minValue: () => 'Указанное значение меньше минимально допустимого',
    between: () => 'Указанное значение находится вне допустимого диапазона',
    length: () => `Требуемая длина - ${v.$params.length.min} символов`,
    minLength: (v) => `Минимальная длина - ${v.$params.minLength.min} символов`,
    maxLength: (v) => `Максимальная длина - ${v.$params.maxLength.max} символов`,
    numeric: () => 'Значение должно состоять только из цифр'
};
